import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';

import { cn } from '../../utils/cn';

/**
 * Vaul drag handle for bottom drawers. Pair with `handleOnly` on `Drawer` so
 * pointer capture on the handle routes move events to vaul's drag logic.
 */
export const DrawerHandle = React.forwardRef<
    React.ElementRef<typeof DrawerPrimitive.Handle>,
    React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Handle>
>(({ className, children, style, ...props }, ref) => (
    <DrawerPrimitive.Handle
        ref={ref}
        className={cn(
            'mx-auto mt-0.5 hidden min-h-11 w-full shrink-0 items-center justify-center group-data-[vaul-drawer-direction=bottom]/drawer-content:flex',
            className,
        )}
        style={{ touchAction: 'none', ...style }}
        {...props}
    >
        {children ?? (
            <span
                className="block h-1 w-9.5 rounded-full bg-gray-600/30"
                aria-hidden
            />
        )}
    </DrawerPrimitive.Handle>
));

DrawerHandle.displayName = 'DrawerHandle';
